export interface DeviceState {
  isMobile: boolean;
}

export const initialDeviceState: DeviceState = {
  isMobile: false,
};
